import { Localized } from "@fluent/react";
import { DocumentWorkflowActions } from "../documentsApi";

type Props = {
  action: DocumentWorkflowActions;
};

export const ActionTitle = ({ action }: Props) => {
  switch (action) {
    case "Finish":
      return (
        <Localized id="document-action-finish">
          <span>_Oznacz jako zakończony</span>
        </Localized>
      );

    case "FinishEdition":
      return (
        <Localized id="document-action-finish-edition">
          <span>_Zakończ edytowanie</span>
        </Localized>
      );

    case "FinishOpinion":
      return (
        <Localized id="document-action-finish-opinion">
          <span>_Zakończ opiniowanie</span>
        </Localized>
      );

    case "ForceFinishOpinion":
      return (
        <Localized id="document-action-force-finish-opinion">
          <span>_Wymuś zakończenie opiniowania</span>
        </Localized>
      );

    case "ForceFinishApproval":
      return (
        <Localized id="document-action-force-finish-approval">
          <span>_Wymuś zakończenie zatwierdzania</span>
        </Localized>
      );

    case "Approve":
      return (
        <Localized id="document-action-approve">
          <span>_Zatwierdź dokument</span>
        </Localized>
      );

    case "Reject":
      return (
        <Localized id="document-action-reject">
          <span>_Odrzuć dokument</span>
        </Localized>
      );

    case "SendToOpinion":
      return (
        <Localized id="document-action-send-to-opinion">
          <span>_Wyślij do opiniowania</span>
        </Localized>
      );

    case "ResendToOpinion":
      return (
        <Localized id="document-action-send-to-opinion-again">
          <span>_Wyślij ponownie do opiniowania</span>
        </Localized>
      );
    case "SendToCorrection":
      return (
        <Localized id="document-action-send-to-correction">
          <span>Send to correction</span>
        </Localized>
      );
    case "SendToApprove":
      return (
        <Localized id="document-action-send-to-approve">
          <span>_Wyślij do zatwierdzenia</span>
        </Localized>
      );

    case "WithdrawFromOpinion":
      return (
        <Localized id="document-action-withdraw-from-opinion">
          <span>_Wycofaj z opiniowania</span>
        </Localized>
      );
    case "SendToDiscussion":
      return (
        <Localized id="document-action-send-to-discussion">
          <span>_Wyślij do dyskusji</span>
        </Localized>
      );
    default: 
      return <span>{action}</span>;
  }
};

export const ActionContent = ({ action }: Props) => {
  switch (action) {
    case "Finish":
      return (
        <Localized id="document-action-finish-question">
          <span>_Czy na pewno chcesz oznaczyć dokument jako zakończony?</span>
        </Localized>
      );

    case "FinishOpinion":
      return (
        <Localized id="document-action-finish-opinion-question">
          <span>_Czy na pewno chcesz zakończyć opiniowanie dokumentu?</span>
        </Localized>
      );

    case "FinishEdition":
      return (
        <Localized id="document-action-finish-edition-question">
          <span>_Czy na pewno chcesz zakończyć edycję dokumentu?</span>
        </Localized>
      );

    case "ForceFinishOpinion":
      return (
        <Localized id="document-action-force-finish-opinion-question">
          <span>_Czy na pewno chcesz wymusić zakończenie opiniowania dokumentu?</span>
        </Localized>
      );

    case "ForceFinishApproval":
      return (
        <Localized id="document-action-force-finish-approval-question">
          <span>_Czy na pewno chcesz wymusić zakończenie zatwierdzania dokumentu?</span>
        </Localized>
      );

    case "Approve":
      return (
        <Localized id="document-action-approve-question">
          <span>_Czy na pewno chcesz zatwierdzić dokument?</span>
        </Localized>
      );

    case "Reject":
      return (
        <Localized id="document-action-reject-question">
          <span>_Czy na pewno chcesz odrzucić dokument?</span>
        </Localized>
      );

    case "SendToOpinion":
      return (
        <Localized id="document-action-send-to-opinion-question">
          <span>_Czy na pewno chcesz wysłać dokument do opiniowania?</span>
        </Localized>
      );

    case "ResendToOpinion":
      return (
        <Localized id="document-action-send-to-opinion-again-question">
          <span>_Czy na pewno chcesz ponownie wysłać dokument do opiniowania?</span>
        </Localized>
      );
    case "SendToCorrection":
      return (
        <Localized id="document-action-send-to-correction-question">
          <span>Do you want to send the document to correction?</span>
        </Localized>
      );
    case "SendToApprove":
      return (
        <Localized id="document-action-send-to-approve-question">
          <span>_Czy na pewno chcesz wysłać dokument do zatwierdzenia?</span>
        </Localized>
      );

    case "WithdrawFromOpinion":
      return (
        <Localized id="document-action-withdraw-from-opinion-question">
          <span>_Czy na pewno chcesz wycofać dokument z opiniowania? Wycofanie anuluje wykonane opinie.</span>
        </Localized>
      );
    case "SendToDiscussion":
      return (
        <Localized id="document-action-send-to-discussion-question">
          <span>_Wyślij do dyskusji</span>
        </Localized>
      );
    default:
      return <span></span>;
  }
};